module.exports = __webpack_public_path__ + "static/media/Chip.5e2c554a.svg";